import { render, staticRenderFns } from "./Tv.vue?vue&type=template&id=1cba67c5&scoped=true&"
import script from "./Tv.vue?vue&type=script&lang=js&"
export * from "./Tv.vue?vue&type=script&lang=js&"
import style0 from "./Tv.vue?vue&type=style&index=0&id=1cba67c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cba67c5",
  null
  
)

export default component.exports